import { useDynamicModule } from "@grandvisionhq/utils";
import { dynamicLoadPhoneNumberInput } from "./dynamic-load-phone-number-input.js";
const usePhoneNumberInputPackage = () => useDynamicModule(dynamicLoadPhoneNumberInput, "react-phone-number-input/min", []);
export {
  usePhoneNumberInputPackage
};
//# sourceMappingURL=use-phone-number-input-package.js.map
